import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const DragDropArea = styled.div<{ $isDragActive: boolean }>`
  border: 2px dashed
    ${props =>
      props.$isDragActive ? COLORS.primaryDark : COLORS.secondarySemiLight};
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  background-color: ${props =>
    props.$isDragActive ? COLORS.primaryExtraLight : COLORS.white};
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: ${COLORS.primaryDark};
    background-color: ${COLORS.primaryExtraLight};
  }
`

export const DragDropContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
`

export const DragText = styled.p`
  font-size: 16px;
  color: ${COLORS.secondarySemiDark};
  margin: 0;
  font-weight: 500;
`

export const OrText = styled.p`
  font-size: 14px;
  color: ${COLORS.secondary};
  margin: 0;
  position: relative;
  padding: 0 20px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 40px;
    height: 1px;
    background-color: ${COLORS.secondarySemiLight};
  }

  &::before {
    left: -50px;
  }

  &::after {
    right: -50px;
  }
`

export const ButtonsRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const DragDropWrapper = styled.div<{ $isDragActive: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`
